import { render, staticRenderFns } from "./SingleMaterial.vue?vue&type=template&id=5119910c"
import script from "./SingleMaterial.vue?vue&type=script&lang=js"
export * from "./SingleMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports